import React from 'react';

const ViewReportButton = () => (
  <button
    onClick={() => window.open("https://viewvalue.io/reports/form10k/2023/papajohns/5kL9Tq0s/", "_blank")}
    className="bg-green-600 text-white px-6 py-3 rounded-xl font-medium hover:bg-green-700 transition w-full"
  >
    View Report
  </button>
);

export default ViewReportButton;
